"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
exports.Container = (0, styled_1.default)('div') `
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')};
  a {
    color: ${(0, ui_theme_1.fromTheme)('color_link')};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
  h3 {
    line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  }
`;
//# sourceMappingURL=styles.js.map